import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  socialNetworksLoad,
  socialNetworksSetEnabled,
  socialNetworksUpsert,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(socialNetworksLoad.type, send, socket);
  yield takeEvery(socialNetworksSetEnabled.type, send, socket);
  yield takeEvery(socialNetworksUpsert.type, send, socket);
}
